import { Box, HStack, useToken } from 'native-base';
import React, { ReactNode } from 'react';

import HTML from 'app/components/HTML';
import { Reservation2 } from 'app/components/icons';
import { AttractionConfig, ReservationRequirement } from 'app/services/GuestCenterService.types';
import { ReservationTextHelper } from 'app/services/I18n';

export type ReservationRequirementLabelProps = {
  children?: ReactNode;
  attrConfig: AttractionConfig | undefined;
  rt: ReservationTextHelper;
  fontSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  pt?: number;
};

export default function ReservationRequirementLabel({
  attrConfig,
  rt,
  fontSize,
  pt = 0,
}: ReservationRequirementLabelProps) {
  const brandPrimary = useToken('colors', 'brand.primary');
  const size = useToken('fontSizes', fontSize ?? 'md');
  const notRequired = attrConfig?.reservationRequirement === ReservationRequirement.NotRequired;

  return (
    <Box pt={pt} testID="ReservationRequirement">
      {notRequired ? (
        <HTML fontSize={fontSize} html={rt('reservation_not_required')} />
      ) : (
        <HStack alignItems="center" space="1">
          <Reservation2 color={brandPrimary} size={size} />
          <Box flexShrink="1">
            <HTML
              bold
              color="brand.primary"
              fontSize={fontSize}
              html={rt('reservation_required')}
              lineHeight={16}
            />
          </Box>
        </HStack>
      )}
    </Box>
  );
}
